/**
 * Maps auth API errors (from BFF) to user-facing messages (pt-BR).
 */

export interface AuthErrorLike {
  error?: string;
  message?: string;
  fields?: Record<string, string>;
}

/** Returns field-level errors from Bonamassa when present (e.g. validation_failed). */
export function getAuthErrorFields(err: unknown): Record<string, string> | undefined {
  const e = err as AuthErrorLike;
  if (e?.error === "validation_failed" && e?.fields && Object.keys(e.fields).length > 0) {
    return e.fields;
  }
  return undefined;
}

export function getAuthErrorMessage(err: unknown): string {
  const e = err as AuthErrorLike & { status?: number };
  if (e?.error === "email_not_verified" || e?.message?.toLowerCase().includes("verified")) {
    return "Confirme seu e-mail antes de entrar. Verifique sua caixa de entrada.";
  }
  if (e?.error === "invalid email or password" || e?.status === 401) {
    return "E-mail ou senha incorretos. Tente novamente.";
  }
  if (e?.error === "validation_failed" && e?.fields) {
    const first = Object.values(e.fields)[0];
    return first ?? "Verifique os dados e tente novamente.";
  }
  if (e?.error === "email already registered" || e?.error === "email_already_registered" || e?.status === 409) {
    return e?.message ?? "Este e-mail já está cadastrado. Faça login com e-mail/senha ou verifique o e-mail antes de vincular o Google.";
  }
  if ((e as Error)?.message === "auth_not_configured") {
    return "Login não configurado. Em produção, defina PRD_BFF_URL no deploy (URL do ezy-bff). Localmente, use um arquivo .env com PRD_BFF_URL.";
  }
  if (e?.message) return e.message;
  if (typeof e?.error === "string") return e.error;
  if (e?.status === 0 || (e as Error)?.message === "Failed to fetch") {
    return "Não foi possível conectar. Verifique sua internet e tente novamente.";
  }
  return "Algo deu errado. Tente novamente.";
}
